import { freeze } from '@rehaje/shared'

export const defaultLocales = freeze({
  defaultValue: '默认值',
  id: '唯一标识',
  setValue: '设置值',
  type: '类型',
  value: '值'
})
